<div class="login-modal-container">
  <div class="close icon-close" (click)="close()"></div>
  <form id="login-form" (submit)="login()" autocomplete="on">
    <div class="login-modal-body">
      <div class="login-modal-content">
        <div class="login-title-container">
          <span class="login-title">Session Expired</span>
          <span class="login-subtitle">Please login to continue.</span>
        </div>
        <div class="login-modal-main">
          @if (!svc.originIsController) {
            <lib-selector-input
              [fieldName]="'Edge Controller'"
              [(fieldValue)]="selectedEdgeController"
              [placeholder]="'Select an Edge Controller'"
              [valueList]="edgeControllerList"
              (fieldValueChange)="edgeChanged($event)"
              >
            </lib-selector-input>
          }
          <div class="username-pass-container">
            <div class="input-fields-container">
              <label for="Username" class="userlogin open" [ngClass]="{'login-disabled': showNoControllers}">Username</label>
              <input
                id="Username"
                name="username"
                type="text"
                autocomplete="on"
                required
                [ngClass]="{'login-disabled': showNoControllers}"
                [placeholder]="'Enter your ziti admin username'"
                [(ngModel)]="username"
                >
            </div>
          </div>
          <div class="input-fields-container">
            <label for="Password" class="userlogin open" [ngClass]="{'login-disabled': showNoControllers}">Password</label>
            <input
              id="Password"
              name="password"
              type="password"
              autocomplete="on"
              required
              [ngClass]="{'login-disabled': showNoControllers}"
              [placeholder]="'Enter your ziti admin password'"
              [(ngModel)]="password"
              >
          </div>
          @if (loginFailed) {
            <span class="login-error-message">Login Failed</span>
          }
        </div>
      </div>
    </div>
    <div class="login-buttons-container">
      <button class="button" type="submit">Login</button>
      <div class="linkButton cancel" (click)="returnToLoginPage()">Return to login page</div>
    </div>
  </form>
</div>
